import { applyCustomDomainEntry } from './customDomainEntry';

const isSsoCallback =
  window.location.hostname.startsWith('sso') ||
  (window.location.hostname.startsWith('localhost') && window.location.href.includes('clientId=sso'));

const start = async () => {
  if (isSsoCallback) {
    await import('./bootstrap-sso');
    return;
  }

  // A bare visit to a custom domain may be sent elsewhere before the app is even requested.
  if (await applyCustomDomainEntry()) return;

  await import('./bootstrap');
};

void start();
